import { DateBox } from 'devextreme-react';
import React from 'react';

export const FormDate = ({ field, form: { touched, errors, setFieldValue }, ...props }) => {
  const { col, label, onChange, type = 'date' } = props;
  const { value, name } = field;

  return (
    <div className={`col-lg-${col}`}>
      <div className={`form-group ${errors[field.name] ? 'has-error' : null}`}>
        <label className="control-label">{label}</label>
        <DateBox
          value={value}
          name={name}
          {...props}
          isValid={!errors[field.name]}
          type={type}
          useMaskBehavior
          onValueChanged={option => {
            setFieldValue(field.name, option ? option.value : '');

            onChange && onChange(option);
          }}
        />

        {touched[field.name] && errors[field.name] && (
          <span className="help-block m-b-none">{errors[field.name]}</span>
        )}
      </div>
    </div>
  );
};
